const MenuState = {
    HIDDEN: 0,
    FULL: 1,
    SHORT: 2
};

export default MenuState;